import React, { Component } from 'react';
import gql from 'graphql-tag';
import {
  Card, Container, Grid, Alert, Loader,
} from 'tabler-react';
import client from '../client';

const unsubscribeMutation = gql`
mutation unsubscribe($token: String!) {
  unsubscribe(token: $token)
}
`;

class Unsubscribe extends Component {
  state = { loading: true, error: null };

  async componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (!token) {
      this.setState({ loading: false, error: 'This unsubscribe link is invalid.' });
      return;
    }

    try {
      await client.mutate({ mutation: unsubscribeMutation, variables: { token } });
      this.setState({ loading: false });
    } catch (e) {
      this.setState({ loading: false, error: e.message.replace('GraphQL error: ', '') });
    }
  }

  render() {
    const { loading, error } = this.state;
    return (
      <Container>
        <Grid.Row>
          <Grid.Col className="mx-auto mt-6 col-login">
            <Card>
              <Card.Body>
                { loading && <Loader /> }
                { !loading && error && <Alert type="danger">{error}</Alert> }
                { !loading && !error && (
                  <React.Fragment>
                    <Card.Title>You've been unsubscribed</Card.Title>
                    <p>You will no longer receive keyword alert emails from BidFTA Toolkit.</p>
                    <p>Changed your mind? Email <a href="mailto:support@bidft.auction">support@bidft.auction</a> to resubscribe.</p>
                  </React.Fragment>
                ) }
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>
      </Container>
    );
  }
}

export default Unsubscribe;



// WEBPACK FOOTER //
// ./src/unsubscribe/index.js